import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useCoreWebVitalMetrics from 'hooks/useCoreWebVitalMetrics';

import './Page.scss';
import { useSelector } from 'react-redux';
import { getTrackingPixelData } from 'store/selectors/getTrackingPixelData';
import TrackingPixel from '../../tracking/TrackingPixel';

export function Page({
	children,
	className,
	landingPage,
	pageType,
}) {
	const trackingData = useSelector((state) => getTrackingPixelData(state));
	useCoreWebVitalMetrics(pageType);
	return (
		<div
			className={classnames('page', className, {
				'landing-page': landingPage,
			})}
		>
			<TrackingPixel
				id="pagePixelSrc"
				trackingData={trackingData}
			/>
			<TrackingPixel
				id="visitVerifySrc"
				trackingData={trackingData}
			/>
			{children}
		</div>
	);
}

Page.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	landingPage: PropTypes.bool,
	pageType: PropTypes.string,
	trackingData: PropTypes.object,
};

export default Page;
